module.exports = __webpack_public_path__ + "media/images/aero-9048319f.png";